/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const competitionCategoryDtoSchema = z.object({
  name: z.optional(z.string()),
  meaning: z.optional(z.string()),
  examples: z.optional(z.array(z.string())),
  relevance: z.optional(z.string()),
});
